export const NotificationType = [
  {
    label: "Nombre, Fecha y Hora",
    value: 1,
  },
  {
    label: "Nombre, Fecha, Hora y Booking Id",
    value: 2,
  },
  {
    label: "Nombre, Informacion del Conductor, Hora y Ubicaciones",
    value: 3,
  },
];

export const ContingencyNotificationType = [
  {
    label: "Nombre y direcciones",
    value: 4,
  },
];
